// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35_L1","badges":"styles_badges__2FOwz"};